module.exports = __webpack_public_path__ + "img/clients-01.63042cc4.svg";